<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      botToken: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    botToken: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const telegramChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            channel: {
              type: 'telegram',
              bot_token: this.botToken,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: telegramChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="ch-form-page h-full w-full overflow-y-auto">
    <div class="ch-form-page__intro">
      <h2 class="ch-form-page__title">
        {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.TITLE') }}
      </h2>
      <p class="ch-form-page__desc">
        {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.DESC') }}
      </p>
    </div>

    <form @submit.prevent="createChannel()">
      <!-- Bot Token -->
      <div class="ch-form-row">
        <div class="ch-form-row__label-col">
          <label class="ch-form-label">{{
            $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.BOT_TOKEN.LABEL')
          }}</label>
          <p class="ch-form-hint">
            {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.BOT_TOKEN.SUBTITLE') }}
          </p>
        </div>
        <div class="ch-form-row__control-col">
          <input
            v-model="botToken"
            type="text"
            class="ch-input"
            :class="{ 'ch-input--error': v$.botToken.$error }"
            :placeholder="
              $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.BOT_TOKEN.PLACEHOLDER')
            "
            @blur="v$.botToken.$touch"
          />
          <p v-if="v$.botToken.$error" class="ch-form-error">
            {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.BOT_TOKEN.ERROR') }}
          </p>
        </div>
      </div>

      <!-- Submit -->
      <div class="ch-form-footer">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<style scoped>
.ch-form-page {
  padding: 28px 32px 80px;
  max-width: 860px;
  background: #ffffff;
  box-sizing: border-box;
}
.ch-form-page__intro {
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e5e7eb;
}
.ch-form-page__title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 6px;
}
.ch-form-page__desc {
  font-size: 13px;
  color: #4b5563;
  margin: 0;
}
.ch-form-row {
  display: flex;
  gap: 24px;
  padding: 16px 0;
  border-bottom: 1px solid #f3f4f6;
}
.ch-form-row__label-col {
  width: 240px;
  flex-shrink: 0;
}
.ch-form-row__control-col {
  flex: 1;
  min-width: 0;
}
.ch-form-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 2px;
}
.ch-form-hint {
  font-size: 12px;
  color: #6b7280;
  margin: 4px 0 0;
  line-height: 1.5;
}
.ch-input {
  display: block;
  width: 100%;
  max-width: 400px;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #111827;
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
}
.ch-input:focus {
  border-color: #4384f5;
  box-shadow: 0 0 0 3px rgba(67, 132, 245, 0.12);
}
.ch-input--error {
  border-color: #ef4444;
}
.ch-form-error {
  font-size: 12px;
  color: #ef4444;
  margin: 4px 0 0;
}
.ch-form-footer {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}
</style>
